/**
 * 菜单
 */

export default [
  {
    path: '/per/perEntryPage.action',
    name: '入职管理',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_set_entry']
    }
  },
  {
    path: '/org/toOrgPage.action',
    name: '组织管理',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_org_manage']
    }
  },
  {
    path: '/job/toJobPage.action',
    name: '岗位管理',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_post_manage']
    }
  },
  {
    path: '/per/toPerList.action',
    name: '员工管理',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_emp_manage']
    }
  },
  {
    path: '/contract/toContractManage.action',
    name: '合同管理',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_contract_manage']
    }
  },
  {
    path: '/atndclockrecord/toindex.action',
    name: '打卡记录',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_clock_record']
    }
  },
  {
    path: '/atndresult/toindex.action',
    name: '考勤结果处理',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_atnd_result']
    }
  },
  {
    path: '/atndmonthlyreport/toindex.action',
    name: '考勤月报',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_atnd_report']
    }
  },
  {
    path: '/atndmonthlyreport/toSummary.action',
    name: '考勤汇总',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_atnd_sum']
    }
  },
  {
    path: '/atnddaily/toDailyReport.action',
    name: '考勤日报',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_atnd_day_report']
    }
  },
  {
    path: '/vacnstandard/queryindex.action',
    name: '休假查询',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_vanc_record']
    }
  },
  {
    path: '/healthHr/toHealthPage.action',
    name: '健康打卡',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_health_record']
    }
  },
  // 宁波乾象
  {
    path: '/nbqx/index.action',
    name: '数据统计',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/nbqx/index.vue`),
    meta: {
      permission: ['hr_emp_metashares']
    }
  },{
  path: '/sys/code/SysCodeSet.action',
    name: '代码设置',
    component: () => import ( /* webpackChunkName: "step2" */ `@/views/sys/code/SysCodeSet.vue`),
    meta: {
      permission: ['set_system']
    }
  },{
    path: '/sys/codeItem',
      name: '代码设置',
      component: () => import ( /* webpackChunkName: "step2" */ `@/views/sys/code/SysCodeItem.vue`),
      meta: {
        permission: ['set_system']
      }
  }
];
